module.exports = __webpack_public_path__ + "static/media/prize-6.cb86a6ef.png";